module.exports = __webpack_public_path__ + "static/media/medal.5553336a.svg";